import usePitchListStore from 'components/sections/pitch-list/store/use-pitch-list-store';
import { useEffect } from 'react';
import { useTrainedMsStore } from 'stores/use-trained-ms-store';

// whenever tmsDict updates, mixin anything that needs to update/be removed
const useMixinTmsListener = () => {
  const tmsDict = useTrainedMsStore((s) => s.tmsDict);

  useEffect(() => {
    usePitchListStore.getState().mixinTms();
  }, [tmsDict]);
};

export default useMixinTmsListener;
